import { render, staticRenderFns } from "./FriendRequestItem.vue?vue&type=template&id=298a7782"
import script from "./FriendRequestItem.vue?vue&type=script&lang=js"
export * from "./FriendRequestItem.vue?vue&type=script&lang=js"
import style0 from "./FriendRequestItem.vue?vue&type=style&index=0&id=298a7782&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports